export default "__VITE_ASSET__19ae2aa7__"